import { useEffect, type ReactNode } from "react";
import { SITE } from "@shared/site/site-config";
import "./page-shell.css";

type Props = {
  eyebrow?: string;
  title: string;
  lead?: string;
  children: ReactNode;
  width?: "reading" | "wide";
  /** "viewport" pages never scroll: the heading sits beside the panel and both fit the window. */
  layout?: "flow" | "viewport";
};

/** The frame of every page but the hero: an eyebrow, a title, a lead, controlled width. */
export function PageShell({
  eyebrow,
  title,
  lead,
  children,
  width = "reading",
  layout = "flow",
}: Props) {
  useEffect(() => {
    document.title = `${title} | ${SITE.name}`;
  }, [title]);

  return (
    <main className="page-shell" data-width={width} data-layout={layout} id="main">
      <header className="page-shell__header">
        {eyebrow ? (
          <p className="page-shell__eyebrow">
            <span className="page-shell__pip" aria-hidden="true" />
            {eyebrow}
          </p>
        ) : null}
        <h1 className="page-shell__title">{title}</h1>
        {lead ? <p className="page-shell__lead">{lead}</p> : null}
      </header>
      {children}
    </main>
  );
}
